import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Badge, Menu } from 'antd';
import Icon from '@ant-design/icons';
import useTranslation from 'utils/hooks/useTranslation';
import { useFeatureFlag } from 'components/Providers/FeatureFlag';
import { useGetPendingFundingRequestsCount } from 'services/reactQueryHooks/wireTransfers';
import styles from './style.module.scss';
import { staffUserMenuItems } from './helper';

const StaffUserMenu = ({ onMenuClick, selectedKeys, theme, isSuperAdmin }) => {
  const { translateText } = useTranslation();
  const { showFeature } = useFeatureFlag();

  // Populates the Funding Requests badge as soon as this menu mounts (i.e. as soon
  // as a staff user lands in the admin area), not only once that page is visited.
  const { pendingCount: pendingFundingRequestsCount } = useGetPendingFundingRequestsCount();

  return (
    <div>
      <div className={styles.staffUserDivider} />
      <Menu
        data-testid="staffUserMenu"
        theme={theme}
        onClick={onMenuClick}
        selectedKeys={selectedKeys}
        mode="inline"
        className={styles.navigation}
      >
        {staffUserMenuItems.map(menuItem => {
          if (!isSuperAdmin && menuItem.superAdminViewOnly) {
            return null;
          }
          if (menuItem.feature && !showFeature(menuItem.feature)) {
            return null;
          }
          const showBadge = menuItem.key === 'fundingRequests' && pendingFundingRequestsCount > 0;
          return (
            <Menu.Item key={menuItem.key} disabled={menuItem.disabled}>
              <Link
                to={menuItem.url}
                className={classNames(styles.menuLink, { [styles.menuLinkWithBadge]: showBadge })}
                data-testid={
                  selectedKeys.includes(menuItem.key) ? `selectedMenuItem-${menuItem.key}` : null
                }
              >
                <Icon component={menuItem.component} className={styles.icon} />
                <span className={styles.title}>
                  {translateText(`corporateAccounts.menuLeft.${menuItem.key}`, menuItem.title)}
                </span>
                {showBadge && (
                  <Badge
                    count={pendingFundingRequestsCount}
                    className={styles.menuItemBadge}
                    data-testid="fundingRequestsMenuBadge"
                  />
                )}
              </Link>
            </Menu.Item>
          );
        })}
      </Menu>
    </div>
  );
};

export default StaffUserMenu;
